import { render } from "./Stundenplan.vue?vue&type=template&id=56ef2a18"
import script from "./Stundenplan.vue?vue&type=script&lang=js"
export * from "./Stundenplan.vue?vue&type=script&lang=js"
script.render = render

export default script